//You can't have a Link without a `to` prop: https://github.com/ReactTraining/react-router/issues/2319
import React from "react"
import { Spacer } from "./Atoms"
import styled from "styled-components"

const BottomLinkMobileOnlyStyledWrapper = styled.div`
  @media screen and (max-width: 599px) {
    position: absolute;
    bottom: 24px;
  }
`
const FleLinkWrapper = ({ children, spacerHeight = 3 }) => (
  <>
    <Spacer height={spacerHeight} expand />
    <div className="flex flex-row-reverse justify-between items-center">{children}</div>
  </>
)

const InfoCircle = ({ onClick }) => (
  <div className="flex flex-row items-center ml2 pointer dim" onClick={onClick}>
    <img height="18px" src="/images/InfoCircle.svg" alt="" />
  </div>
)

export { InfoCircle, BottomLinkMobileOnlyStyledWrapper, FleLinkWrapper }
